import React from "react";
import { withTranslation } from "react-i18next";
import { Form, DatePicker, Typography } from "antd";
import moment from "moment";
import styled from "styled-components";

import { SEC_FONT_GREY } from "../../constant/colors";

const { Text } = Typography;

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const OrderDateFormItemComponent = ({
  t,
  style,
  title,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  defaultValue,
  dataTMId,
  name = "orderDate",
  recordInfo
}) => {
  const momentDefaultValue = defaultValue ? moment(defaultValue) : null;

  return (
    <FormItemStyled
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={
        showLabel ? (
          <Text strong={strong} style={{ color: "#9B9B9B" }}>
            {title ? title : t("form.order_date.label")}
          </Text>
        ) : null
      }
      style={style}
      colon={false}
      rules={[{ required, message: t("form.order_date.error_required") }]}
    >
      {editable ? (
        <DatePicker
          style={{ width: "100%" }}
          placeholder={t("form.order_date.placeholder")}
          disabled={!editable}
          format={"MM/DD/YYYY"}
          allowClear={true}
          defaultValue={momentDefaultValue}
        />
      ) : (
        <Text data-tm-id={dataTMId}>{defaultValue ? `${moment(defaultValue).format("MM/DD/YYYY")}` : "-"}</Text>
      )}
    </FormItemStyled>
  );
};

const OrderDateFormItem = withTranslation()(OrderDateFormItemComponent);

export { OrderDateFormItem };
